/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getByCompanyAsync$Json } from '../fn/open-invitation-config/get-by-company-async-json';
import { GetByCompanyAsync$Json$Params } from '../fn/open-invitation-config/get-by-company-async-json';
import { getByCompanyAsync$Plain } from '../fn/open-invitation-config/get-by-company-async-plain';
import { GetByCompanyAsync$Plain$Params } from '../fn/open-invitation-config/get-by-company-async-plain';
import { getByCompanyIdAsync$Json } from '../fn/open-invitation-config/get-by-company-id-async-json';
import { GetByCompanyIdAsync$Json$Params } from '../fn/open-invitation-config/get-by-company-id-async-json';
import { getByCompanyIdAsync$Plain } from '../fn/open-invitation-config/get-by-company-id-async-plain';
import { GetByCompanyIdAsync$Plain$Params } from '../fn/open-invitation-config/get-by-company-id-async-plain';
import { getByIdAsync$Json } from '../fn/open-invitation-config/get-by-id-async-json';
import { GetByIdAsync$Json$Params } from '../fn/open-invitation-config/get-by-id-async-json';
import { getByIdAsync$Plain } from '../fn/open-invitation-config/get-by-id-async-plain';
import { GetByIdAsync$Plain$Params } from '../fn/open-invitation-config/get-by-id-async-plain';
import { OpenInvitationConfigCto } from '../models/open-invitation-config-cto';
import { updateAsync$Json } from '../fn/open-invitation-config/update-async-json';
import { UpdateAsync$Json$Params } from '../fn/open-invitation-config/update-async-json';
import { updateAsync$Plain } from '../fn/open-invitation-config/update-async-plain';
import { UpdateAsync$Plain$Params } from '../fn/open-invitation-config/update-async-plain';

@Injectable({ providedIn: 'root' })
export class OpenInvitationConfigService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getByCompanyAsync()` */
  static readonly GetByCompanyAsyncPath = '/open-invitation-config/company/{companyGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByCompanyAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCompanyAsync$Plain$Response(params: GetByCompanyAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OpenInvitationConfigCto>>> {
    return getByCompanyAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByCompanyAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCompanyAsync$Plain(params: GetByCompanyAsync$Plain$Params, context?: HttpContext): Observable<Array<OpenInvitationConfigCto>> {
    return this.getByCompanyAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OpenInvitationConfigCto>>): Array<OpenInvitationConfigCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByCompanyAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCompanyAsync$Json$Response(params: GetByCompanyAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OpenInvitationConfigCto>>> {
    return getByCompanyAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByCompanyAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCompanyAsync$Json(params: GetByCompanyAsync$Json$Params, context?: HttpContext): Observable<Array<OpenInvitationConfigCto>> {
    return this.getByCompanyAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OpenInvitationConfigCto>>): Array<OpenInvitationConfigCto> => r.body)
    );
  }

  /** Path part for operation `getByCompanyIdAsync()` */
  static readonly GetByCompanyIdAsyncPath = '/open-invitation-config/company-id/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByCompanyIdAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCompanyIdAsync$Plain$Response(params: GetByCompanyIdAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OpenInvitationConfigCto>>> {
    return getByCompanyIdAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByCompanyIdAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCompanyIdAsync$Plain(params: GetByCompanyIdAsync$Plain$Params, context?: HttpContext): Observable<Array<OpenInvitationConfigCto>> {
    return this.getByCompanyIdAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OpenInvitationConfigCto>>): Array<OpenInvitationConfigCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByCompanyIdAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCompanyIdAsync$Json$Response(params: GetByCompanyIdAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OpenInvitationConfigCto>>> {
    return getByCompanyIdAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByCompanyIdAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByCompanyIdAsync$Json(params: GetByCompanyIdAsync$Json$Params, context?: HttpContext): Observable<Array<OpenInvitationConfigCto>> {
    return this.getByCompanyIdAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OpenInvitationConfigCto>>): Array<OpenInvitationConfigCto> => r.body)
    );
  }

  /** Path part for operation `getByIdAsync()` */
  static readonly GetByIdAsyncPath = '/open-invitation-config/company/{companyGuid}/document/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByIdAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByIdAsync$Plain$Response(params: GetByIdAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OpenInvitationConfigCto>> {
    return getByIdAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByIdAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByIdAsync$Plain(params: GetByIdAsync$Plain$Params, context?: HttpContext): Observable<OpenInvitationConfigCto> {
    return this.getByIdAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OpenInvitationConfigCto>): OpenInvitationConfigCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByIdAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByIdAsync$Json$Response(params: GetByIdAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OpenInvitationConfigCto>> {
    return getByIdAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByIdAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByIdAsync$Json(params: GetByIdAsync$Json$Params, context?: HttpContext): Observable<OpenInvitationConfigCto> {
    return this.getByIdAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<OpenInvitationConfigCto>): OpenInvitationConfigCto => r.body)
    );
  }

  /** Path part for operation `updateAsync()` */
  static readonly UpdateAsyncPath = '/open-invitation-config/company/{companyGuid}/document/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAsync$Plain$Response(params: UpdateAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OpenInvitationConfigCto>> {
    return updateAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAsync$Plain(params: UpdateAsync$Plain$Params, context?: HttpContext): Observable<OpenInvitationConfigCto> {
    return this.updateAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OpenInvitationConfigCto>): OpenInvitationConfigCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAsync$Json$Response(params: UpdateAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OpenInvitationConfigCto>> {
    return updateAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAsync$Json(params: UpdateAsync$Json$Params, context?: HttpContext): Observable<OpenInvitationConfigCto> {
    return this.updateAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<OpenInvitationConfigCto>): OpenInvitationConfigCto => r.body)
    );
  }

}
